import { User } from '../../../api/backend/types/users';
import { SchedulerOperatorOnMachine } from './operator-on-machine';
import { SchedulerItemOnMachine } from './item-on-machine';
import { MoldRevisionItem } from '../../mold/models/item';
import { MachinesDeadTimes } from 'src/app/api/elite/types/machines-dead-times';

export abstract class SchedulerMachine {
  id: number;
  title: string;
  shortName?: string;
  machinesOperators: SchedulerOperatorOnMachine[];
  maintenanceTypeId: number = undefined;
  maintenanceType: { id: number; title: string };
  machineDeadTimes: MachinesDeadTimes | null;
  maxOperators: number;
  _maxQueueActive: number;
  typeId: number;

  private _moldRevisions: MoldRevisionItem[] = [];
  set moldRevisions(value: MoldRevisionItem[]) {
    this._activeMold = value.find((el) => el.locationName === this.title);
    this._moldRevisions = value;
  }
  get moldRevisions(): MoldRevisionItem[] {
    return this._moldRevisions;
  }

  private _activeMold: MoldRevisionItem;
  get activeMold(): MoldRevisionItem {
    return this._activeMold;
  }

  get maxQueueActive(): number {
    return this._maxQueueActive;
  }
  private set maxQueueActive(value: number) {
    this._maxQueueActive = value;
  }
  _maxOrderActive: number;
  get maxOrderActive(): number {
    return this._maxOrderActive;
  }
  private set maxOrderActive(value: number) {
    this._maxOrderActive = value;
  }

  abstract get machineItems(): SchedulerItemOnMachine[];
  /**
   * Returns the users currently assigned to this machine.
   *
   * IMPORTANT: every department backend should populate `user.uid` inside the
   * join row, because that uid is what we send when adding / removing
   * operators (`POST /machines/operators/remove` expects
   * `{ machineId, operatorId }` where `operatorId === user.uid`).
   *
   * The compression `/work-order/data-by-machine/:id` endpoint, however,
   * returns the join row with a `user` object that lacks `uid`, even though
   * the row itself carries `operatorId` (the foreign key). Without a
   * fallback, the operator entry renders fine (because name/lastname are
   * present) but `removeOperator` sends `operatorId: undefined` and the
   * backend rejects the call.
   *
   * To keep this resilient across departments we hydrate `uid` from
   * `operatorId` whenever the nested user is missing it. Existing departments
   * whose backend already returns `user.uid` are not affected — the
   * conditional only fires when `uid` is falsy.
   */
  get operators(): User[] {
    return (this.machinesOperators ?? []).map((operatorOnMachine) => {
      const user = operatorOnMachine.user ?? ({} as User);
      if (!user.uid && operatorOnMachine.operatorId) {
        return { ...user, uid: operatorOnMachine.operatorId };
      }
      return user;
    });
  }
}
